import { Component, OnInit } from '@angular/core';
import { StorageService } from 'src/app/core/services/storage.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { CategoryService } from 'src/app/core/services/category.service';

@Component({
  selector: 'app-submit-confirmation',
  templateUrl: './submit-confirmation.component.html',
  styleUrls: ['./submit-confirmation.component.css']
})
export class SubmitConfirmationComponent implements OnInit {
  isArabic: any;
  message: string = '';
  messageOne: string = '';
  redirectTo: string = '';
  cancelButton!: boolean;
  constructor(private storageService: StorageService, public bsModalRef: BsModalRef, private route: Router,
    private categoryService: CategoryService) { }

  ngOnInit(): void {
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    this.categoryService.setSubmitConfirmation('');
  }

  closeNotification(isOkay?: boolean) {
    if (isOkay && this.cancelButton) {
      this.bsModalRef.hide();
      this.categoryService.setSubmitConfirmation('ok');
    } else {
      if (this.bsModalRef) {
        this.bsModalRef.hide();
        if (this.redirectTo != '') {
          this.route.navigate([this.redirectTo]);
        }
      }
    }
  }

}
